import { ColumnProps } from "@monolith-forensics/monolith-ui";
import { DocumentTemplate } from "../DocumentTemplates.types";
import { monolithMoment } from "@/utils/date-format";

export const DocumentTemplateColumnDefinitions: ColumnProps[] = [
  {
    dataField: "name",
    caption: "Template Name",
  },
  {
    dataField: "description",
    caption: "Description",
  },
  {
    dataField: "created_by",
    caption: "Created By",
    render: ({ rowData }: { rowData: DocumentTemplate }) =>
      rowData.created_by?.full_name,
  },
  {
    dataField: "created_on",
    caption: "Created On",
    render: ({ rowData }: { rowData: DocumentTemplate }) =>
      monolithMoment({ timestamp: rowData.created_on }),
  },
];
